import { Link, StaticQuery, graphql } from "gatsby"
import React, { Component, useState } from "react"
import useSessionCookie from "../util/useSessionCookie"
import { signinLink } from "../util/sso"
import { Helmet } from "react-helmet"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import PropTypes from "prop-types"
import onClickOutside from "react-onclickoutside"
// import aboutIcon from "../images/header/about.svg"
// import apiReferenceIcon from "../images/header/api-reference.svg"
// import apiStatusIcon from "../images/header/api-status.svg"
// import docsIcon from "../images/header/docs.svg"
// import jobsIcon from "../images/header/jobs.svg"
// import learnIcon from "../images/header/learn.svg"
// import newsroomIcon from "../images/header/newsroom.svg"
// import publicationsIcon from "../images/header/publications.svg"
// import supportIcon from "../images/header/support.svg"
// import technologyIcon from "../images/header/technology.svg"
// import investorsIcon from "../images/header/investors.svg"

import "./Header.scss"

const IONQ_CLOUD_UI_BASE_URL = process.env.GATSBY_IONQ_CLOUD_UI_BASE_URL

// disable some element-interaction warns bc we use them for display only, so still a11y friendly
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
class OffCanvasNav extends Component {
  handleClickOutside(e) {
    this.props.closeMenu()
  }

  render() {
    const {
      isLoggedIn,
      isMobile,
      location,
      closeMenu,
      isOpen,
      updateProductsMenuIsOpen,
      updateCompanyMenuIsOpen,
      updateResourcesMenuIsOpen,
      updateAccountMenuIsOpen,
      productsMenuIsOpen,
      companyMenuIsOpen,
      resourcesMenuIsOpen,
      accountMenuIsOpen,
      onLogoutClick,
    } = this.props

    // const browser = typeof window !== "undefined" && window;

    const fireSegment = eventName => {
      if (typeof window !== "undefined" && window.analytics) {
        window.analytics.track("Console Engagement", {
          engagement_type: eventName
        })
      }
    }

    return (
      <StaticQuery
        query={
          graphql`
            query QuantumSystemsQuery {
              allContentfulQuantumSystem(sort:{navigationPosition:ASC}) {
                nodes {
                  slug
                  name
                  mainNavigationDescription
                }
              }
            }
          `
        }
        render={(data) => (
          <nav
            aria-label="main navigation"
            className={isOpen ? "-menu-open header-nav" : "header-nav"}
          >
            <Helmet>
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
            </Helmet>
            {isOpen && (
              <button
                className="close-trigger"
                onClick={closeMenu}
                aria-label="close menu"
              ></button>
            )}
            {/* Products Drop Down Menu Start */}
            <div className="header-nav-item header-nav-item--left">
              <span
                role="button"
                tabIndex="0"
                className="header-nav-link -heading"
                onFocus={() => {
                  updateProductsMenuIsOpen(true)
                  updateResourcesMenuIsOpen(false)
                  updateCompanyMenuIsOpen(false)
                }}
                onKeyPress={e => {
                  if (e.key === " " || "Enter")
                    updateProductsMenuIsOpen(!productsMenuIsOpen)
                }}
                onClick={() => {
                  updateProductsMenuIsOpen(!productsMenuIsOpen)
                }}
                onMouseEnter={() => {
                  if (!isMobile) {
                    updateProductsMenuIsOpen(true)
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    updateProductsMenuIsOpen(false)
                  }
                }}
              >
                Products
                <span
                  className={`material-symbols-outlined -mobile ${
                    productsMenuIsOpen ? " -open" : ""
                  }`}
                >
                  expand_more
                </span>
              </span>
              <ul
                role="navigation"
                aria-label="Products"
                className={`header-products-menu${
                  productsMenuIsOpen ? " -open" : ""
                }`}
                onMouseEnter={() => {
                  updateProductsMenuIsOpen(true)
                }}
                onMouseLeave={() => {
                  updateProductsMenuIsOpen(false)
                }}
              >
                <div className="nav-container -half -spaced">
                  <span className="nav-container -header">Quantum Systems</span>
                  <div className="nav-container-box">
                    <li className="nav-container-content">
                      <Link
                        className="header-submenu-item"
                        to="/quantum-systems/compare"
                        onClick={() => {
                          updateProductsMenuIsOpen(true)
                        }}
                      >
                        <span className="header-submenu-item-label">Compare Quantum Systems</span>
                        <span className="header-submenu-item-description">
                          Explore and compare IonQ’s industry leading portfolio of quantum computers
                        </span>
                      </Link>
                    </li>
                    {
                      data.allContentfulQuantumSystem.nodes.map(system => (
                        <li className="nav-container-content" key={system.slug}>
                          <Link
                            className="header-submenu-item"
                            to={`/quantum-systems/${system.slug}`}
                            state={{ system: system.name }}
                            onClick={() => {
                              updateProductsMenuIsOpen(true)
                            }}
                          >
                            <span className="header-submenu-item-label">
                              {system.name}
                            </span>
                            <span className="header-submenu-item-description">
                              {system.mainNavigationDescription}
                            </span>
                        </Link>
                      </li>
                      ))
                    }
                    <li className="nav-container-content show_only_mobile">
                      <Link
                        className="header-submenu-item"
                        to="/algorithmic-qubits"
                        onClick={() => {
                          updateProductsMenuIsOpen(true)
                        }}
                      >
                        <span className="header-submenu-item-label">About #AQ</span>
                      </Link>
                    </li>
                  </div>
                </div>
                <div className="nav-container -half">
                  <div className="nav-container-box -no-gap">
                    <li className="nav-container-content show_only_desktop">
                      <div className="nav-container -spaced">
                        <span className="nav-container -header">Quantum Consulting</span>
                        <Link
                          className="header-submenu-item"
                          to="/applications-services"
                          onClick={() => {
                            updateResourcesMenuIsOpen(false)
                          }}
                        >
                          <span className="header-submenu-item-label">
                            Applications
                          </span>
                          <span className="header-submenu-item-description">
                            Quantum solutions to your most pressing business challenges with IonQ application team
                          </span>
                        </Link>
                      </div>
                    </li>
                    <div className="nav-container-box">
                      <li className="nav-container-content show_only_desktop">
                        <div className="nav-container -spaced">
                          <span className="nav-container -header">Systems Benchmark</span>
                          <Link
                            className="header-submenu-item"
                            to="/algorithmic-qubits"
                            onClick={() => {
                              updateResourcesMenuIsOpen(false)
                            }}
                          >
                            <span className="header-submenu-item-label">
                              About #AQ
                            </span>
                            <span className="header-submenu-item-description">
                              A benchmark that measures what matters most: a system’s value to your organization
                            </span>
                          </Link>
                        </div>
                      </li>
                    </div>
                    <div className="nav-container -spaced">
                      <span className="nav-container -header">
                        Cloud
                      </span>
                      <div className="nav-container-box">
                        <li className="nav-container-content">
                          <Link
                            className="header-submenu-item"
                            to="/quantum-cloud"
                            onClick={() => {
                              updateProductsMenuIsOpen(true)
                            }}
                          >
                            <span className="header-submenu-item-label">
                              Quantum Cloud
                            </span>
                            <span className="header-submenu-item-description">
                              Harness the power of IonQ Quantum Systems from the cloud
                            </span>
                          </Link>
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
            {/* Products Drop Down Menu End */}
            {/* Company Drop Down Menu Start */}
            <div className="header-nav-item header-nav-item--centered">
              <span
                role="button"
                tabIndex="0"
                className="header-nav-link -heading"
                onFocus={() => {
                  updateCompanyMenuIsOpen(true)
                  updateResourcesMenuIsOpen(false)
                  updateProductsMenuIsOpen(false)
                }}
                onKeyPress={e => {
                  if (e.key === " " || "Enter")
                    updateCompanyMenuIsOpen(!companyMenuIsOpen)
                }}
                onClick={() => {
                  updateCompanyMenuIsOpen(!companyMenuIsOpen)
                }}
                onMouseEnter={() => {
                  if (!isMobile) {
                    updateCompanyMenuIsOpen(true)
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    updateCompanyMenuIsOpen(false)
                  }
                }}
              >
                Company{" "}
                <span
                  className={`material-symbols-outlined -mobile ${
                    companyMenuIsOpen ? " -open" : ""
                  }`}
                >
                  expand_more
                </span>
              </span>
              <ul
                role="navigation"
                aria-label="Company"
                className={`header-company-menu${
                  companyMenuIsOpen ? " -open" : ""
                }`}
                onMouseEnter={() => {
                  if (!isMobile) {
                    updateCompanyMenuIsOpen(true)
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    updateCompanyMenuIsOpen(false)
                  }
                }}
              >
                <div className="nav-container -full">
                  <div className="nav-container-box">
                    <li className="nav-container-content">
                      <Link
                        className="header-submenu-item"
                        to="/company"
                        onClick={() => {
                          updateCompanyMenuIsOpen(false)
                        }}
                      >
                        <span className="header-submenu-item-label">
                          About IonQ
                        </span>
                        <span className="header-submenu-item-description">
                          History and leadership
                        </span>
                      </Link>
                    </li>
                    <li className="nav-container-content">
                      <Link
                        className="header-submenu-item"
                        to="/news"
                        onClick={() => {
                          updateCompanyMenuIsOpen(false)
                        }}
                      >
                        <span className="header-submenu-item-label">Newsroom</span>
                        <span className="header-submenu-item-description">
                          Announcements, coverage, and press resources
                        </span>
                      </Link>
                    </li>
                    <li className="nav-container-content">
                      <a
                        className="header-submenu-item"
                        href="https://investors.ionq.com"
                        target={"_blank"}
                        onClick={() => {
                          updateCompanyMenuIsOpen(false)
                        }}
                      >
                        <span className="header-submenu-item-label">
                          Investor Relations
                        </span>
                        <span className="header-submenu-item-description">
                          Governance, filings, and investor resources
                        </span>
                      </a>
                    </li>
                    <li className="nav-container-content">
                      <Link
                        className="header-submenu-item"
                        to="/contact"
                        onClick={() => {
                          updateCompanyMenuIsOpen(false)
                        }}
                      >
                        <span className="header-submenu-item-label">
                          Contact Us
                        </span>
                        <span className="header-submenu-item-description">
                          Have a question? We're here to help.
                        </span>
                      </Link>
                    </li>
                    <li className="nav-container-content -mobile">
                      <Link
                        className="header-submenu-item"
                        to="/careers"
                        onClick={() => {
                          updateCompanyMenuIsOpen(false)
                        }}
                      >
                        <span className="header-submenu-item-label">Careers</span>
                        <span className="header-submenu-item-description"></span>
                      </Link>
                    </li>
                  </div>
                </div>
              </ul>
            </div>
            {/* Company Menu End */}

            {/* Resources Menu Start */}
            <div className="header-nav-item header-nav-item--centered">
              <span
                role="button"
                tabIndex="0"
                className="header-nav-link -heading"
                to="/resources"
                onFocus={() => {
                  if (!isMobile) {
                    updateResourcesMenuIsOpen(true)
                    updateCompanyMenuIsOpen(false)
                    updateProductsMenuIsOpen(false)
                    updateAccountMenuIsOpen(false)
                  }
                }}
                onKeyPress={e => {
                  if (e.key === " " || "Enter")
                    updateResourcesMenuIsOpen(!resourcesMenuIsOpen)
                }}
                onClick={() => {
                  updateResourcesMenuIsOpen(!resourcesMenuIsOpen)
                }}
                onMouseEnter={() => {
                  if (!isMobile) {
                    updateResourcesMenuIsOpen(true)
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    updateResourcesMenuIsOpen(false)
                  }
                }}
              >
                Resources{" "}
                <span
                  className={`material-symbols-outlined -mobile ${
                    resourcesMenuIsOpen ? " -open" : ""
                  }`}
                >
                  expand_more
                </span>
              </span>
              <ul
                role="navigation"
                aria-label="Learn"
                className={`header-resources-menu${
                  resourcesMenuIsOpen ? " -open" : ""
                }`}
                onMouseEnter={() => {
                  if (!isMobile) {
                    updateResourcesMenuIsOpen(true)
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobile) {
                    updateResourcesMenuIsOpen(false)
                  }
                }}
              >
                <div className="nav-container -full">
                  <div className="nav-container-box">
                    <li className="nav-container-content">
                      <Link
                        className="header-submenu-item"
                        to="/resources"
                        onClick={() => {
                          updateResourcesMenuIsOpen(false)
                        }}
                      >
                        <span className="header-submenu-item-label">
                          Resource Center
                        </span>
                        <span className="header-submenu-item-description">
                          Level up your quantum knowledge
                        </span>
                      </Link>
                    </li>
                    <li className="nav-container-content">
                      <Link
                        className="header-submenu-item"
                        to="/events"
                        onClick={() => {
                          updateResourcesMenuIsOpen(false)
                        }}
                      >
                        <span className="header-submenu-item-label">
                          Events
                        </span>
                        <span className="header-submenu-item-description">
                          Stay up to date on the latest webinars and events
                        </span>
                      </Link>
                    </li>
                     <li className="nav-container-content">
                      <Link
                        className="header-submenu-item"
                        to="https://docs.ionq.com/"
                        target="_blank"
                        onClick={() => {
                          updateResourcesMenuIsOpen(false)
                        }}
                      >
                        <span className="header-submenu-item-label">
                          Documentation
                        </span>
                        <span className="header-submenu-item-description">
                          View guides, user manuals and API reference
                        </span>
                      </Link>
                    </li>
                    <li className="nav-container-content">
                      <Link
                        className="header-submenu-item"
                        to="/resources/glossary"
                        onClick={() => {
                          updateResourcesMenuIsOpen(false)
                        }}
                      >
                        <span className="header-submenu-item-label">
                          Quantum Glossary
                        </span>
                        <span className="header-submenu-item-description">
                          Learn common quantum terminology
                        </span>
                      </Link>
                    </li>
                    <li className="nav-container-content">
                      <Link
                        className="header-submenu-item"
                        to="/technology"
                        onClick={() => {
                          updateResourcesMenuIsOpen(false)
                        }}
                      >
                        <span className="header-submenu-item-label">
                          Technology
                        </span>
                        <span className="header-submenu-item-description">
                          Understanding trapped ion technology
                        </span>
                      </Link>
                    </li>
                    <li
                      className="nav-container-content"
                      onClick={() => {
                        updateResourcesMenuIsOpen(false)
                      }}
                    >
                      <Link
                        className="header-submenu-item"
                        to="/resources/publications"
                      >
                        <span className="header-submenu-item-label">
                          Publications
                        </span>
                        <span className="header-submenu-item-description">
                          Research and journal articles from IonQ scientists
                        </span>
                      </Link>
                    </li>
                    <li className="nav-container-content">
                      <a
                        className="header-submenu-item -status"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://status.ionq.co/"
                      >
                        <span className="header-submenu-item-label">
                          System Status
                        </span>
                        <span className="header-submenu-item-description">
                          View the status of our QPUs and Simulators
                        </span>
                      </a>
                    </li>
                    <li className="nav-container-content">
                      <a
                        className="header-submenu-item"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://support.ionq.com/"
                      >
                        <span className="header-submenu-item-label">Support</span>
                        <span className="header-submenu-item-description">
                          Get help from our experts
                        </span>
                      </a>
                    </li>
                    <li
                      className="nav-container-content -mobile"
                      onClick={() => {
                        updateResourcesMenuIsOpen(false)
                      }}
                    >
                      <Link className="header-submenu-item" to="/blog">
                        <span className="header-submenu-item-label">Blog</span>
                      </Link>
                    </li>
                  </div>
                </div>
              </ul>
            </div>
            {/* Resources Menu End */}
            {/* Careers Link Start */}
            <div className="header-nav-item -desktop">
              <Link
                onFocus={() => {
                  updateCompanyMenuIsOpen(false)
                  updateResourcesMenuIsOpen(false)
                  updateProductsMenuIsOpen(false)
                  updateAccountMenuIsOpen(false)
                }}
                className="header-nav-link -solo-item"
                to="/careers"
                onKeyPress={e => {
                  if (e.key === " " || "Enter") closeMenu()
                }}
                onClick={closeMenu}
              >
                Careers
              </Link>
            </div>
            {/* Careers Link End */}

            {/* Blog Menu Start */}
            <div className="header-nav-item -desktop">
              <Link
                onFocus={() => {
                  updateCompanyMenuIsOpen(false)
                  updateResourcesMenuIsOpen(false)
                  updateProductsMenuIsOpen(false)
                  updateAccountMenuIsOpen(false)
                }}
                className="header-nav-link -solo-item"
                to="/blog"
                onKeyPress={e => {
                  if (e.key === " " || "Enter") closeMenu()
                }}
                onClick={closeMenu}
              >
                Blog
              </Link>
            </div>
            {/* Blog Menu End */}

            {/* Sign In Menu Item */}
            {!isLoggedIn && (
              <div className={`header-nav-item header-nav-item--spacer`}>
                <a
                  className="header-nav-link -solo-item"
                  href={signinLink(location ? location.pathname : "")}
                  onClick={() => {
                    // closeMenu
                  }}
                >
                  Sign In
                </a>
              </div>
            )}
            {/* Sign In Menu Item End */}

            {/* My Account Menu Item Start */}
            {isLoggedIn && (
              <div
                className={`header-nav-item header-nav-item--spacer header-nav-item--centered`}
              >
                <span
                  role="button"
                  tabIndex="0"
                  className="header-nav-link -heading"
                  onFocus={() => {
                    updateCompanyMenuIsOpen(false)
                    updateResourcesMenuIsOpen(false)
                    updateProductsMenuIsOpen(false)
                    updateAccountMenuIsOpen(true)
                  }}
                  onKeyPress={e => {
                    if (e.key === " " || "Enter")
                      updateAccountMenuIsOpen(!accountMenuIsOpen)
                  }}
                  onClick={() => {
                    fireSegment("my_account")
                    updateAccountMenuIsOpen(!accountMenuIsOpen)
                  }}
                  onMouseEnter={() => {
                    if (!isMobile) {
                      updateAccountMenuIsOpen(true)
                    }
                  }}
                  onMouseLeave={() => {
                    if (!isMobile) {
                      updateAccountMenuIsOpen(false)
                    }
                  }}
                >
                  My Account
                </span>
                <ul
                  role="navigation"
                  aria-label="My Account"
                  className={`header-account-menu${
                    accountMenuIsOpen ? " -open" : ""
                  }`}
                  onMouseEnter={() => {
                    if (!isMobile) {
                      updateAccountMenuIsOpen(true)
                    }
                  }}
                  onMouseLeave={() => {
                    if (!isMobile) {
                      updateAccountMenuIsOpen(false)
                    }
                  }}
                >
                  <div className="nav-container -full">
                    <div className="nav-container-box">
                      <li className="nav-container-content">
                        <a
                          className="header-submenu-item"
                          href={`${IONQ_CLOUD_UI_BASE_URL}/settings/account`}
                          target="_blank"
                        >
                          <span className="header-submenu-item-label">
                            Account Settings
                          </span>
                          <span className="header-submenu-item-description">
                            Manage your profile and password
                          </span>
                        </a>
                      </li>
                      <li className="nav-container-content">
                        <button
                          className="header-submenu-item"
                          onClick={onLogoutClick}
                        >
                          <span className="header-submenu-item-label">
                            Sign out
                          </span>
                          {/* <span className="header-submenu-item-description">
                              Lorem
                            </span> */}
                        </button>
                      </li>
                    </div>
                  </div>
                </ul>
              </div>
            )}
            {/* My Account Menu Item End */}

            {!isLoggedIn && (
              <div className="header-nav-item">
                <Link className="cta-link" to="https://identity.ionq.com/create-account" onClick={closeMenu}>
                  Sign Up
                </Link>
              </div>
            )}

            {isLoggedIn && (
              <div className="header-nav-item">
                <a
                  className="cta-link"
                  target="_blank"
                  href={`${IONQ_CLOUD_UI_BASE_URL}`}
                  onClick={() => {
                    fireSegment("cloud_console")
                    closeMenu()
                  }}
                >
                  Cloud Console
                </a>
              </div>
            )}
          </nav>
        )}
      />
    )
  }
}

OffCanvasNav = onClickOutside(OffCanvasNav)

const Header = ({
  isMobile,
  location,
  openMenu,
  closeMenu,
  isOpen,
  darkMode,
}) => {
  const [session, removeSession] = useSessionCookie()
  const [resourcesMenuIsOpen, updateResourcesMenuIsOpen] = useState(false)
  const [companyMenuIsOpen, updateCompanyMenuIsOpen] = useState(false)
  const [productsMenuIsOpen, updateProductsMenuIsOpen] = useState(false)
  const [accountMenuIsOpen, updateAccountMenuIsOpen] = useState(false)

  return (
    <header aria-label="site header with logo and navigation">
      <AnchorLink className="skip-link" to="#main">
        skip to content
      </AnchorLink>
      <div className={`Header ${darkMode ? "-dark-mode" : ""}`}>
        <Link
          className={`logo-link ${isOpen ? "-menu-open" : ""}`}
          to="/"
          aria-label="to homepage"
        ></Link>
        {!isOpen && (
          <button
            className="open-trigger"
            onClick={() => {
              openMenu()
              updateProductsMenuIsOpen(true)
              updateResourcesMenuIsOpen(false)
              updateCompanyMenuIsOpen(false)
              updateAccountMenuIsOpen(false)
            }}
            aria-label="open menu"
          >
            <span />
          </button>
        )}
        <OffCanvasNav
          isLoggedIn={!session.isLoading && session.user}
          isMobile={isMobile}
          location={location}
          closeMenu={closeMenu}
          isOpen={isOpen}
          productsMenuIsOpen={productsMenuIsOpen}
          companyMenuIsOpen={companyMenuIsOpen}
          resourcesMenuIsOpen={resourcesMenuIsOpen}
          accountMenuIsOpen={accountMenuIsOpen}
          updateCompanyMenuIsOpen={updateCompanyMenuIsOpen}
          updateProductsMenuIsOpen={updateProductsMenuIsOpen}
          updateResourcesMenuIsOpen={updateResourcesMenuIsOpen}
          updateAccountMenuIsOpen={updateAccountMenuIsOpen}
          onLogoutClick={() => removeSession()}
        />
      </div>
    </header>
  )
}

Header.propTypes = {
  openMenu: PropTypes.func.isRequired,
  closeMenu: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
}

export default Header
